import fetchApi from 'services/fetch';
import { boAPI } from 'constants/api';
import { track, generateServerResponseError, generateMessageDisplayedSegment } from 'utils/segmenTracker';
import { ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents';

const initialState = {
  qrData: {},
  paymentOrder: {},
  formData: { cardNumber: '', date: '', cvv: '', name: '', autoDebit: '' },
  errors: {
    cardNumber: { value: false, message: 'Búscalo en el frente' },
    date: { value: false, message: 'Búscala en el frente' },
    cvv: { value: false, message: 'Búscalo al reverso' },
    name: { value: false },
  },
};

export const payment = {
  state: { ...initialState },
  reducers: {
    updateFormData(state, payload) {
      return {
        ...state,
        formData: { ...state.formData, ...payload },
      };
    },
    updateError(state, payload) {
      return {
        ...state,
        errors: payload,
      };
    },
    updateQRData(state, payload) {
      return { ...state, qrData: payload };
    },
    updatePaymentOrder(state, payload) {
      return { ...state, paymentOrder: payload };
    },
    clearStore() {
      return { ...initialState };
    },
  },
  effects: (dispatch) => {
    return {
      async getPaymentQR(params) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: boAPI.getPaymentQR,
          data: { ...params },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            this.updateQRData({
              raw: response?.data?.body,
              qrImage: response?.data?.body?.paymentInstruction?.[0]?.payment_instructions[0]?.value,
            });
            return Promise.resolve({ success: true, data: response?.data });
          })
          .catch((error) => {
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                error,
                ACTIVATION,
                'Get Payment QR',
                boAPI.getPaymentQR,
                'Get Payment QR API'
              ),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(error, ACTIVATION, 'Get Payment QR API'),
            });
            return Promise.resolve({ success: false, error: error?.rawResponse });
          });
      },
      async submitPaymentCard(params) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: boAPI.submitPaymentCard,
          data: { ...params },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, response: response?.data });
          })
          .catch((error) => {
            dispatch.apiStatus.setRequestFailed({ ...error });
            return Promise.resolve({ success: false, error: error?.rawResponse });
          });
      },
      async getPaymentStatus(params) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: boAPI.getPaymentStatus,
          data: { ...params },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, data: response?.data });
          })
          .catch((error) => {
            const msg = error?.rawResponse?.errors?.[0]?.userMessage || '';
            dispatch.apiStatus.setRequestFailed({ ...error, message: msg });
            return Promise.resolve({ success: false });
          });
      },
    };
  },
};
